<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <template v-if="searchShow">
            <div class="item-son">
              <el-input
                  v-model="listParams.searchKey"
                  placeholder="搜索关键词"
                  clearable
                  @keyup.enter.native="SearchAdvertisemenList"
              ></el-input>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  placeholder="请选择状态"
                  style="width: 120px"
              >
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button  type="primary" @click="SearchAdvertisemenList"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </template>

          <div class="item-son" v-if="addShow">
            <el-button  type="primary" @click="handleClick('add')"
              >新增 <img src="@assets/images/add-icon.png" alt="" />
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
        ref="multipleTable"
        size="medium"
        :data="tableData"
        border
        style="width: 100%"
        row-key="menuId"
        v-loading="loading"
        element-loading-text="等待接口数据返回中······"
      >
        <el-table-column
              align="center"
              fixed
              label="序号"
              type="index"
              width="100"
            >
              <template slot-scope="scope">
                <span>{{
                  (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>

        <el-table-column prop="name" label="名称" width="240" align="center">
        </el-table-column>

        <el-table-column prop="adSite" label="标识" width="200" align="center">
        </el-table-column>

        <el-table-column
          prop="width"
          label="建议宽高"
          width="250"
          align="center"
        >
          <template slot-scope="scope">
            {{ `${scope.row.width} * ${scope.row.height} ${scope.row.unit}` }}
          </template>
        </el-table-column>
        <el-table-column prop="descr" label="说明" width="200" align="center">
        </el-table-column>

        <el-table-column prop="seq" label="排序" width="120" align="center">
        </el-table-column>
        <el-table-column prop="code" label="状态" width="110" align="center">
          <template slot-scope="scope">
            <el-switch
                :disabled="statusShow"
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeSwitch(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
                v-if="editShow"
              size="mini"
              @click="handleClick('edit', scope.row)"
              type="warning"
              plain
              >编辑</el-button
            >
            <el-button
                v-if="deleteShow"
              size="mini"
              @click="handleDelete(scope.row)"
              type="primary"
              plain
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageNo"
          :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
      title="增加/编辑广告位置"
      :visible.sync="dialogVisible"
      width="460px"
      :close-on-click-modal="false"
      class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="params"
          label-width="85px"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              placeholder="请填写名称"
              v-model="params.name"
              style="width: 100%"
            ></el-input>
          </el-form-item>

          <el-form-item label="标识" prop="adSite">
            <el-input
              placeholder="请填写广告位置标识"
              v-model="params.adSite"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item label="宽（px）" prop="width">
            <el-input
              placeholder="请填写广告宽度"
              v-model="params.width"
            ></el-input>
          </el-form-item>

          <el-form-item label="高（px）" prop="height">
            <el-input
              placeholder="请填写广告高度"
              v-model="params.height"
            ></el-input>
          </el-form-item>

          <el-form-item label="说明">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入说明"
              v-model="params.descr"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="序号" prop="seq">
            <el-input
              placeholder="请填写序号"
              v-model="params.seq"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT, JOB_STATUS } from "@config";
export default {
  data() {
    return {
      listParams: {},
      params: {},
      tableData: [],
      total: 0,
      PAGE_SIZE,
      dialogVisible: false,
      isDisabled: false,
      loading: false,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写名称",
            trigger: "change",
          },
        ],
        adSite: [
          {
            required: true,
            message: "请填写广告位置标识",
            trigger: "change",
          },
        ],
        width: [
          {
            required: true,
            message: "请填写广告宽",
            trigger: "change",
          },
        ],
        height: [
          {
            required: true,
            message: "请填写广告高",
            trigger: "change",
          },
        ],
        seq: [
          {
            // required: true,
            message: "请填写序号",
            trigger: "blur",
          },
        ],
      },

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,

    };
  },

  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  created() {
    this.queryTableData();
    this.getPermissionButtonList()
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'ad:site:query') {
            this.searchShow = true
          }
          if (item.code == 'ad:site:add') {
            this.addShow = true
          }
          if (item.code == "ad:site:delete") {
            this.deleteShow = true
          }
          if (item.code == "ad:site:edit") {
            this.editShow = true
          }
          if(item.code == "ad:site:status"){
            this.statusShow = false
          }
        })
      }
    },

    SearchAdvertisemenList(){
      this.pages.pageNo = 1
      this.queryTableData()
    },
    /**
     * 主列表
     */
    async queryTableData() {
      this.loading = true;

      const { data: resData } = await this.$get("ad/site/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if(resData.data){
        resData.data.sort(function (a, b) {
          return b.seq - a.seq;
        });
        this.tableData = resData.data;
        this.total = resData.page.count;
      }else {
        this.tableData = [];
        this.total = 0
      }
    },
    /**
     * 修改广告位置状态
     */
    async changeSwitch(b) {
      const { data: resData } = await this.$put(
        `ad/site/info/status/${b.adSite}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "edit") {
        //编辑
        this.isDisabled = true;
        const { data: resData } = await this.$get(
          `ad/site/info/${row.adSite}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );

        if (resData.result != 200) return;
        this.params = resData.data;
      }
      if (type == "add") {
        this.params = {};
        this.isDisabled = false;
      }
    },

    /**
     * 编辑/新增
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {
            const { data: resData } = await this.$post(
              "ad/site/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            const { data: resData } = await this.$put(
              "ad/site/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
    },

    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: resData } = await this.$delete(
          `ad/site/info/${row.adSite}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.queryTableData();

        this.$message.success("删除成功!");
      });
    },

    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped="">
</style>